export const en = {
  // Common
  common: {
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    back: 'Back',
    previous: 'Previous',
    next: 'Next',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Information',
    create: 'Create',
    update: 'Update',
    creating: 'Creating...',
    updating: 'Updating...',
    saving: 'Saving...',
    deleting: 'Deleting...',
    select: 'Select...',
    selectClient: 'Select client',
    selectBankAccount: 'Select bank account',
    noResults: 'No results found',
    adding: 'Adding...',
    filters: 'Filters',
    clear: 'Clear',
    period: 'Period',
    from: 'From',
    to: 'To',
    startDate: 'Start date',
    endDate: 'End date',
    activeFilters: 'Active filters',
    collapse: 'Collapse',
    expand: 'Expand',
    selectPeriod: 'Select period',
    apply: 'Apply',
    clearFilters: 'Clear filters',
    actions: 'Actions',
    copy: 'Copy',
    viewAll: 'View all',
    bankName: 'Bank Name',
    accountNumber: 'Account Number',
    currency: 'Currency',
    balance: 'Balance',
    bankAccounts: {
      swift: 'SWIFT',
      iban: 'IBAN'
    },
    editAccount: 'Edit Bank Account',
    deleteAccountConfirm: 'Are you sure you want to delete this bank account?',
    comingSoon: 'Coming Soon'
  },

  // Navigation
  nav: {
    companies: 'My Companies',
    invoices: 'Invoices',
    transactions: 'Transactions',
    logout: 'Logout'
  },

  // Authentication
  auth: {
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    loginButton: 'Sign In',
    registerButton: 'Sign Up',
    alreadyHaveAccount: 'Already have an account?',
    noAccount: 'Don\'t have an account?',
    switchToLogin: 'Sign In',
    switchToRegister: 'Sign Up',
    logoutConfirm: 'Are you sure you want to logout?',
    error: 'Authentication error',
    registrationSuccess: 'Registration successful! You can now sign in.',
    passwordsDoNotMatch: 'Passwords do not match',
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 6 characters',
    activation: {
      title: 'Account Activation',
      subtitle: 'Welcome',
      description: 'Set your password to complete account activation',
      activate: 'Activate Account',
      activating: 'Activating...',
      invalidToken: 'Invalid activation link',
      tokenExpired: 'The activation link is invalid or has expired.',
      alreadyActivated: 'Account already activated',
      alreadyActivatedMessage: 'Your account is already activated. You can sign in.'
    }
  },

  // Companies
  companies: {
    title: 'My Companies',
    createCompany: 'Create Company',
    addCompany: 'Add Company',
    companyName: 'Company Name',
    taxId: 'Tax ID/Registration Number',
    vatId: 'VAT ID',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    website: 'Website',
    logoPath: 'Company Logo',
    currentLogo: 'Current Logo',
    country: 'Country',
    city: 'City',
    companyAddress: 'Company address',
    createDescription: 'Fill in your company information',
    editDescription: 'Update company information',
    logoSupport: 'Supported formats: PNG, JPG, JPEG, SVG. Maximum size: 2MB',
    uploading: 'Uploading...',
    upload: 'Upload',
    deleteLogo: 'Delete Logo',
    deleteLogoConfirm: 'Are you sure you want to delete the company logo?',
    deleteLogoError: 'Error deleting logo',
    saving: 'Saving...',
    deleting: 'Deleting...',
    create: 'Create',
    save: 'Save',
    cancel: 'Cancel',
    companyNamePlaceholder: 'Company Name Ltd',
    taxIdPlaceholder: 'VAT123456789 or 1234567890',
    vatIdPlaceholder: 'GB123456789',
    phonePlaceholder: '+48 123 456 789',
    emailPlaceholder: 'info@company.com',
    websitePlaceholder: 'https://company.com',
    countryPlaceholder: 'Poland',
    cityPlaceholder: 'Warsaw',
    addressPlaceholder: 'Example Street 1, Office 123',
    chooseFile: 'Choose File',
    noFileChosen: 'No file chosen',
    details: 'Details',
    name: 'Name',
    bankAccount: 'Bank Account',
    bankAccountName: 'Account Name',
    bankAccountNamePlaceholder: 'e.g.: Main Account',
    addAccount: 'Add Account',
    accountNumber: 'Account Number',
    bankName: 'Bank Name',
    bankAccounts: {
      title: 'Bank Accounts',
      addAccount: 'Add Account',
      accountNumber: 'Account Number',
      bankName: 'Bank Name',
      swift: 'SWIFT',
      iban: 'IBAN'
    },
    correspondentAccount: 'Correspondent Account',
    correspondentBank: 'Correspondent Bank',
    bankAddress: 'Bank Address',
    currency: 'Currency',
    balance: 'Balance',
    editAccount: 'Edit Bank Account',
    deleteAccountConfirm: 'Are you sure you want to delete this bank account?',
    // Tabs
    tabs: {
      overview: 'Overview',
      accounts: 'Accounts',
      invoices: 'Invoices',
      expenses: 'Expenses',
      contracts: 'Contracts',
      counterparties: 'Counterparties',
      bankTransactions: 'Bank Transactions',
      invoiceNumbering: 'Invoice Numbering Settings',
      correctionInvoiceNumbering: 'Correction Invoice Numbering',
      correctionInvoices: 'Correction Invoices',
      users: 'Users',
      settings: 'Settings'
    },
    // Actions
    edit: 'Edit',
    backToList: 'Back to List',
    taxIdLabel: 'Tax ID',
    // Tabs - content
    overview: {
      title: 'Basic Information',
      statistics: 'Statistics',
      name: 'Name',
      taxId: 'Tax ID',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      website: 'Website',
      bankAccountsCount: 'Bank Accounts',
      invoicesCount: 'Invoices (30 days)',
      counterpartiesCount: 'Counterparties',
      transactionsCount: 'Transactions'
    },
    accounts: {
      title: 'Bank Accounts',
      addAccount: 'Add Account',
      addFirstAccount: 'Add First Account',
      noAccounts: 'Company has no bank accounts yet',
      accountNumber: 'Account',
      balance: 'Balance',
      edit: 'Edit',
      updateError: 'Error updating account',
      deleteError: 'Error deleting account'
    },
    invoices: {
      title: 'Invoices',
      createInvoice: 'Create Invoice',
      createFirstInvoice: 'Create First Invoice',
      searchPlaceholder: 'Search invoices...',
      allStatuses: 'All Statuses',
      noInvoices: 'Company has no invoices yet',
      noInvoicesFound: 'No invoices found',
      allInvoicesLoaded: 'All invoices loaded',
      totalInvoices: 'Total invoices',
      clearFilters: 'Clear Filters',
      loading: 'Loading invoices...',
      client: 'Client',
      date: 'Date',
      dueDate: 'Due Date',
      details: 'Details',
      viewPdf: 'View PDF',
      downloadPdf: 'Download PDF',
      edit: 'Edit',
      viewDetails: 'View Details',
      download: 'Download',
      copy: 'Copy',
      changeStatus: 'Change Status',
      statuses: {
        DRAFT: 'Draft',
        SENT: 'Sent',
        PARTIALLY_PAID: 'Partially Paid',
        PAID: 'Paid',
        OVERDUE: 'Overdue',
        CANCELLED: 'Cancelled'
      },
      cannotEditNonDraft: 'This invoice cannot be edited because its status is different from "Draft". Only the invoice status can be changed.',
      cannotChangeToDraft: 'Cannot change invoice status to "Draft" if it has already been sent.',
      paymentMethod: 'Payment Method',
      // Invoice import
      importInvoice: 'Import Invoice',
    selectPdfFile: 'Select PDF file',
    parsedData: 'Parsed Data',
      invoiceNumber: 'Invoice Number',
      issueDate: 'Issue Date',
      totalAmount: 'Total Amount',
      buyerName: 'Buyer',
      clientFound: 'Client Found',
      clientNotFound: 'Client Not Found',
      parsingFailed: 'Parsing Failed',
      importing: 'Importing...',
      import: 'Import',
      createCounterparty: 'Create Counterparty',
      createInvoiceFromParsed: 'Create Invoice',
      counterpartyCreated: 'Counterparty created successfully',
      invoiceCreated: 'Invoice created successfully',
      errorCreatingCounterparty: 'Error creating counterparty',
      errorCreatingInvoice: 'Error creating invoice',
      sendAllDrafts: 'Send all drafts',
      sendAllDraftsConfirm: 'Send all invoices with status "Draft" sequentially (by issue date)?',
      sendAllDraftsInProgress: 'Sending...',
      sendAllDraftsProgress: 'Processing invoices',
      sendAllDraftsDone: 'Done',
      sendAllDraftsNoDrafts: 'No invoices with status "Draft"',
      sendAllDraftsFailed: 'Process stopped due to an error'
    },
    expenses: {
      add: 'Add expense',
      edit: 'Edit expense',
      deleteConfirm: 'Delete this expense?',
      search: 'Search by number, title, counterparty...',
      total: 'Total',
      empty: 'No expenses found',
      number: 'Number',
      title: 'Title',
      counterparty: 'Counterparty',
      date: 'Date',
      amount: 'Amount',
      status: 'Status',
      file: 'File',
      uploadFile: 'Upload',
      allCounterparties: 'All counterparties',
      fileTypeError: 'Only PDF, PNG, JPG, JPEG are allowed',
      fileSizeError: 'File size must not exceed 10MB',
      netAmount: 'Net amount',
      taxAmount: 'Tax amount',
      grossAmount: 'Gross amount',
      category: 'Category',
      notes: 'Notes',
      issueDate: 'Document date',
      dueDate: 'Due date',
      paymentDate: 'Payment date',
      noCounterparties: 'No counterparties',
      statuses: {
        NEW: 'New',
        APPROVED: 'Approved',
        PAID: 'Paid',
        CANCELLED: 'Cancelled'
      }
    },
    contracts: {
      add: 'Add contract',
      edit: 'Edit contract',
      deleteConfirm: 'Delete this contract?',
      search: 'Search by number, title, counterparty...',
      total: 'Total',
      empty: 'No contracts found',
      number: 'Number',
      title: 'Title',
      counterparty: 'Counterparty',
      period: 'Period',
      status: 'Status',
      file: 'File',
      uploadFile: 'Upload',
      allCounterparties: 'All counterparties',
      fileTypeError: 'Only PDF, PNG, JPG, JPEG are allowed',
      fileSizeError: 'File size must not exceed 10MB',
      valueAmount: 'Contract value',
      notes: 'Notes',
      startDate: 'Start date',
      endDate: 'End date',
      noCounterparties: 'No counterparties',
      statuses: {
        DRAFT: 'Draft',
        ACTIVE: 'Active',
        EXPIRED: 'Expired',
        TERMINATED: 'Terminated'
      }
    },
    counterparties: {
      title: 'Counterparties',
      addCounterparty: 'Add Counterparty',
      addFirstCounterparty: 'Add First Counterparty',
      searchPlaceholder: 'Search counterparties...',
      noCounterparties: 'Company has no counterparties yet',
      noCounterpartiesFound: 'No counterparties found',
      clearSearch: 'Clear Search',
      loading: 'Loading counterparties...',
      taxId: 'Tax ID',
      vatId: 'VAT',
      contact: 'Contact',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      city: 'City',
      comment: 'Comment',
      edit: 'Edit',
      delete: 'Delete',
      deleteConfirm: 'Are you sure you want to delete counterparty',
      syncStatus: {
        synced: 'Synced',
        notSynced: 'Not synced',
        noSync: 'No sync'
      },
      syncConfirmTitle: 'Sync with wFirma',
      syncConfirm: 'Create counterparty "{name}" in wFirma?',
      syncInProgress: 'Syncing...',
      syncInProgressMessage: 'Please wait, synchronizing counterparty with wFirma',
      syncSuccessTitle: 'Sync successful',
      syncSuccess: 'Counterparty successfully synchronized with wFirma',
      syncErrorTitle: 'Sync error',
      syncError: 'An error occurred while synchronizing counterparty with wFirma',
      syncClickHint: 'Click to sync with wFirma',
      unsyncAll: 'Unlink from wFirma',
      unsyncAllHint: 'Reset wFirma binding for all counterparties (for re-linking to new wFirma account)',
      unsyncAllConfirm: 'Reset wFirma binding for all counterparties? You can then re-sync with a new wFirma account.',
      unsyncAllSuccess: 'Binding reset',
      syncAll: 'Sync to wFirma',
      syncAllHint: 'Add all counterparties to wFirma',
      syncAllSuccess: 'All counterparties synchronized'
    },
    users: {
      title: 'Company Users',
      addUser: 'Add User',
      email: 'Email',
      role: 'Role',
      noUsers: 'No users found',
      noUsersFound: 'No users found',
      confirmRemove: 'Are you sure you want to remove this user?',
      searchUser: 'User Email',
      searchPlaceholder: 'Enter email...',
      selectedUser: 'Selected',
      emailHint: 'You can add an existing user or create a new one',
      status: 'Status',
      activated: 'Activated',
      notActivated: 'Not Activated',
      linkCopied: 'Link copied to clipboard',
      cannotRemoveSelf: 'Cannot remove yourself',
      accessDenied: 'Access Denied',
      onlyAdminAccess: 'Only company administrator has access to user management.',
      roles: {
        ADMIN: 'Administrator',
        EMPLOYEE: 'Employee',
        VIEWER: 'Viewer'
      }
    },
    import: {
      import: 'Import',
      importing: 'Importing...',
      downloadTemplate: 'Download Template',
      selectFile: 'Select File',
      selectedFile: 'Selected File',
      imported: 'Imported',
      errors: 'Errors',
      selectSource: 'Select import source',
      fromFile: 'Import from file',
      fromFileDescription: 'CSV or Excel file',
      fromWFirma: 'Import from wFirma',
      fromWFirmaDescription: 'Import all contractors from wFirma',
      wfirmaNotConfigured: 'First configure wFirma integration in company settings',
      wfirmaImportDescription: 'Imports all contractors from wFirma. Existing contractors will be updated.',
      created: 'Created',
      updated: 'Updated',
      skipped: 'Skipped',
      counterparties: {
        title: 'Import Counterparties'
      },
      bankAccounts: {
        title: 'Import Bank Accounts'
      }
    },
    transactions: {
      title: 'Transactions',
      addTransaction: 'Add Transaction',
      addFirstTransaction: 'Add First Transaction',
      noTransactions: 'Company has no transactions yet'
    },
    bankTransactions: {
      title: 'Bank Transactions',
      importCsv: 'Import CSV',
      autoMatch: 'Auto Match',
      matching: 'Matching...',
      loading: 'Loading transactions...',
      totalTransactions: 'Total Transactions',
      matchedTransactions: 'Matched',
      unmatchedTransactions: 'Unmatched',
      matchingRate: 'Matching Rate',
      unmatchConfirm: 'Are you sure you want to unmatch transaction?',
      deleteConfirm: 'Are you sure you want to delete transaction?',
      // Table
      table: {
        date: 'Date',
        description: 'Description',
        type: 'Type',
        amount: 'Amount',
        status: 'Status',
        actions: 'Actions',
        noTransactions: 'No transactions found'
      },
      // Statuses
      status: {
        matched: 'Matched',
        unmatched: 'Unmatched'
      },
      // Transaction types
      types: {
        INCOME: 'Income',
        EXPENSE: 'Expense'
      },
      // Actions
      actions: {
        match: 'Match',
        unmatch: 'Unmatch',
        delete: 'Delete'
      },
      // Filters
      allAccounts: 'All Accounts',
      transactionType: 'Transaction Type',
      allTypes: 'All Types',
      income: 'Income',
      expense: 'Expense',
      category: 'Category',
      allCategories: 'All Categories',
      searchPlaceholder: 'Search by description, counterparty...',
      type: 'Type',
      // Pagination
      pagination: {
        showing: 'Showing {{count}} of {{total}} transactions'
      }
    }
  },

  // Invoices
  invoices: {
    title: 'Invoices',
    createInvoice: 'Create Invoice',
    invoiceNumber: 'Invoice Number',
    clientId: 'Client',
    issueDate: 'Issue Date',
    dueDate: 'Due Date',
    saleDate: 'Sale Date',
    placeOfIssue: 'Place of Issue',
    invoiceType: 'Invoice Type',
    exchangeRate: 'Exchange Rate',
    exchangeRateTable: 'Exchange Rate Table',
    exchangeRateDate: 'Exchange Rate Date',
    reverseCharge: 'Reverse Charge VAT',
    status: 'Status',
    paymentMethod: 'Payment Method',
    pdfLanguage: 'Invoice Language',
    notes: 'Notes',
    notesPlaceholder: 'Additional information...',
    internalComment: 'Comment',
    internalCommentPlaceholder: 'Internal comment (not displayed on invoice)...',
    internalCommentHint: 'This comment is visible only to you and will not be displayed in the PDF invoice',
    basicInfo: 'Basic Information',
    selectFile: 'Select File',
    parseFile: 'Parse File',
    chooseFile: 'Choose File',
    noFileChosen: 'No file chosen',
    duplicateInvoice: 'Invoice Already Exists',
    duplicateInvoiceMessage: 'An invoice with this number already exists. What would you like to do?',
    saveWithNewNumber: 'Save with new number',
    cancelImport: 'Cancel import',
    editInvoiceNumber: 'Edit invoice number',
    items: 'Items',
    descriptionPlaceholder: 'Service/product description',
    addItem: 'Add Item',
    description: 'Description',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    unitOfMeasure: 'Unit of Measure',
    unitOfMeasures: {
      PIECE: 'pcs',
      HOUR: 'hour',
      DAY: 'day',
      WEEK: 'week',
      MONTH: 'month',
      KG: 'kg',
      TON: 't',
      METER: 'm',
      SQUARE_METER: 'm²',
      CUBIC_METER: 'm³',
      LITER: 'l',
      SET: 'set'
    },
    taxRate: 'VAT %',
    total: 'Total',
    subtotal: 'Subtotal',
    taxAmount: 'Tax Amount',
    grandTotal: 'TOTAL',
    editInvoice: 'Edit Invoice',
    deleteInvoiceConfirm: 'Are you sure you want to delete this invoice?',
    viewPdf: 'View PDF',
    downloadPdf: 'Download PDF',
    download: 'Download',
    copy: 'Copy',
    copyInvoice: 'Copy Invoice',
    create: 'Create',
    createError: 'Error creating invoice',
    importError: 'Error importing invoice',
    pdfViewer: {
      title: 'Invoice preview',
      language: 'Language',
      download: 'Download PDF',
      downloading: 'Downloading...',
      close: 'Close',
      loading: 'Loading PDF...',
      notLoaded: 'PDF not loaded',
      loadPdf: 'Load PDF'
    },
    currency: 'Currency',
    currencies: {
      USD: 'USD - US Dollar',
      EUR: 'EUR - Euro',
      GBP: 'GBP - British Pound',
      CNY: 'CNY - Chinese Yuan',
      CAD: 'CAD - Canadian Dollar',
      PLN: 'PLN - Polish Zloty'
    },
    statuses: {
      DRAFT: 'Draft',
      SENT: 'Sent',
      PARTIALLY_PAID: 'Partially Paid',
      PAID: 'Paid',
      OVERDUE: 'Overdue',
      CANCELLED: 'Cancelled'
    },
    wfirma: {
      sendConfirmTitle: 'Send Invoice to wFirma',
      sendConfirm: 'Send invoice "{number}" to wFirma?',
      alreadySyncedPrompt: 'This invoice has already been sent to wFirma. Send it as a new invoice?',
      sendExistingLink: 'Send without creating a new one',
      sendAsNew: 'Send as new',
      syncing: 'Sending to wFirma...',
      syncingMessage: 'Please wait, sending invoice to wFirma',
      sendSuccessTitle: 'Invoice Sent',
      sendSuccess: 'Invoice successfully sent to wFirma',
      sendErrorTitle: 'Send Error',
      sendError: 'An error occurred while sending invoice to wFirma',
      syncCounterpartyRequired: 'Counterparty Sync Required',
      syncCounterpartyMessage: 'Counterparty "{name}" is not synchronized with wFirma. You need to synchronize the counterparty before sending the invoice.',
      syncCounterparty: 'Sync Counterparty',
      selectVatCodes: 'Select VAT Codes',
      selectVatCodesMessage: 'VAT codes not found for some items. Please select appropriate codes:'
    },
    types: {
      STANDARD: 'Invoice',
      PROFORMA: 'Proforma Invoice',
      STANDARD_NO_VAT: 'Invoice without VAT',
      PROFORMA_NO_VAT: 'Proforma Invoice without VAT'
    },
    paymentMethods: {
      BANK_TRANSFER: 'Bank Transfer',
      CASH: 'Cash'
    },
    units: {
      PIECE: 'pcs.',
      HOUR: 'hour',
      DAY: 'day',
      WEEK: 'week',
      MONTH: 'month',
      KG: 'kg',
      TON: 'ton',
      METER: 'm',
      SQUARE_METER: 'm²',
      CUBIC_METER: 'm³',
      LITER: 'l',
      SET: 'set'
    },
    // Multi-step form
    multiStep: {
      basicInfo: 'Basic Information',
      items: 'Invoice Items',
      currency: 'Exchange Rate',
      review: 'Review',
      next: 'Next',
      back: 'Back',
      addItem: 'Add Item'
    },
    // Import
    import: {
      title: 'Import Invoice',
      uploadTitle: 'Upload Invoice File',
      dragAndDrop: 'Drag and drop a PDF file here, or click to select',
      selectFile: 'Select PDF File',
      uploading: 'Uploading...',
      parsing: 'Processing...',
      fileSelected: 'File selected',
      createCounterparty: 'Create Counterparty',
      createBankAccount: 'Create Bank Account',
      createInvoice: 'Create Invoice',
      counterpartyInfo: 'Counterparty Information',
      bankAccountInfo: 'Bank Account Information',
      invoiceInfo: 'Invoice Information',
      invoiceItems: 'Invoice Items',
      editableItems: 'You can edit the invoice items below:',
      calculatedTotal: 'Calculated Total',
      skipStep: 'Skip this step',
      useExisting: 'Use existing',
      prefilledData: 'Pre-filled data from the uploaded invoice. You can edit any field before creating.',
      steps: {
        upload: 'Upload File',
        counterparty: 'Counterparty',
        bankAccount: 'Bank Account',
        invoice: 'Invoice'
      }
    },
    // Exchange rates
    exchangeRates: {
      title: 'Exchange Rate Selection',
      description: 'To calculate VAT in Polish zloty, you need to select the exchange rate for',
      forDate: 'the date preceding the invoice issue date',
      autoSelected: 'Automatically selected rate for the nearest available date before the issue date. You can change the selection below.',
      selectRate: 'Select exchange rate',
      rateInfo: 'Rate Information',
      date: 'Date',
      rate: 'Rate',
      table: 'Table',
      vatInPln: 'VAT in PLN',
      willBeRequired: 'On the next step, you will need to select an exchange rate to calculate VAT in PLN.',
      selectRateRequired: 'Please select an exchange rate',
      loading: 'Loading exchange rates...',
      noRates: 'Exchange rates not found for the selected date. Please add an exchange rate manually.',
      pleaseSelect: 'Please select an exchange rate from the list below.',
      loadRates: 'Load current exchange rates',
      loadError: 'Failed to load exchange rates. Please try again later.'
    },
    // Review
    reviewStep: {
      title: 'Data Review',
      invoiceNumber: 'Invoice Number',
      client: 'Client',
      invoiceType: 'Invoice Type',
      currency: 'Currency',
      issueDate: 'Issue Date',
      dueDays: 'Due Days',
      days: 'days',
      exchangeRateInfo: 'Exchange Rate',
      rateDate: 'Rate Date',
      positions: 'Items',
      notSelected: 'Not Selected'
    },
    // Validation errors
    validation: {
      required: 'Required',
      invoiceNumberRequired: 'Invoice number is required',
      clientRequired: 'Client is required',
      invoiceTypeRequired: 'Invoice type is required',
      currencyRequired: 'Currency is required',
      issueDateRequired: 'Issue date is required',
      dueDaysRequired: 'Due days is required',
      dueDaysMin: 'Due days must be greater than 0',
      bankAccountRequired: 'Bank account is required',
      accountNumberRequired: 'Account number is required',
      bankAccountNameRequired: 'Account name is required',
      bankNameRequired: 'Bank name is required',
      balanceNonNegative: 'Balance cannot be negative',
      placeOfIssueRequired: 'Place of issue is required',
      descriptionRequired: 'Description is required',
      quantityRequired: 'Quantity is required',
      quantityMin: 'Quantity must be greater than 0',
      unitPriceRequired: 'Unit price is required',
      unitPriceMin: 'Unit price must be greater than 0',
      companyNameRequired: 'Company name is required',
      taxIdRequired: 'Tax ID/Registration Number is required',
      taxIdMinLength: 'Minimum 3 characters',
      taxIdMaxLength: 'Maximum 20 characters',
      vatIdMaxLength: 'Maximum 20 characters',
      emailInvalid: 'Enter a valid email',
      cityRequired: 'City is required',
      fileValidationError: 'File validation error',
      logoUploadError: 'Logo upload error',
      fillRequiredFields: 'Please fill in all required fields'
    }
  },

  // Counterparties
  counterparties: {
    title: 'Counterparties',
    createCounterparty: 'Create Counterparty',
    counterpartyName: 'Counterparty Name',
    contactPerson: 'Contact Person',
    addCounterparty: 'Add Counterparty'
  },

  // Transactions
  transactions: {
    title: 'Bank Transactions',
    noTransactionsFound: 'No transactions found',
    createTransaction: 'Add Transaction',
    import: {
      title: 'Import Transactions',
      bankAccount: 'Bank Account',
      selectFile: 'Select File',
      selectFiles: 'Select Files',
      selectedFiles: 'Selected Files',
      singleFile: 'Single File',
      multipleFiles: 'Multiple Import',
      import: 'Import',
      importing: 'Importing...',
      supportedFormats: 'Supported formats: CSV, TXT, PDF'
    },
    table: {
      date: 'Date',
      description: 'Description',
      counterparty: 'Counterparty',
      amount: 'Amount',
      type: 'Type',
      currency: 'Currency',
      status: 'Status',
      actions: 'Actions'
    },
    statuses: {
      matched: 'Matched',
      unmatched: 'Unmatched',
      income: 'Income',
      expense: 'Expense'
    },
    actions: {
      match: 'Match',
      unmatch: 'Unmatch'
    },
    matching: {
      title: 'Transaction Matching',
      transactionInfo: 'Transaction Information',
      selectInvoice: 'Select Invoice',
      selectInvoicePlaceholder: 'Select invoice to match',
      match: 'Match',
      matching: 'Matching...'
    }
  },

  // Languages
  languages: {
    title: 'Interface Language',
    polishOnly: 'Polski',
    polishEnglish: 'Polski-English',
    english: 'English'
  },

  // Currencies
  currencies: {
    USD: 'USD - US Dollar',
    EUR: 'EUR - Euro',
    CNY: 'CNY - Chinese Yuan',
    GBP: 'GBP - British Pound',
    CAD: 'CAD - Canadian Dollar',
    PLN: 'PLN - Polish Zloty'
  },

  // Counterparties
  counterparty: {
    addTitle: 'Add Counterparty',
    editTitle: 'Edit Counterparty',
    name: 'Name',
    nameRequired: 'Name is required',
    namePlaceholder: 'LLC Counterparty',
    taxId: 'Tax ID',
    taxIdPlaceholder: '123456789012',
    vatId: 'VAT',
    vatIdPlaceholder: 'VAT123456789',
    address: 'Address',
    addressPlaceholder: 'Moscow, Example St, 1',
    country: 'Country',
    countryPlaceholder: 'Poland',
    city: 'City',
    cityPlaceholder: 'Warsaw',
    comment: 'Comment',
    commentPlaceholder: 'Enter a comment...',
    contactPerson: 'Contact Person',
    contactPersonPlaceholder: 'John Doe',
    email: 'Email',
    emailPlaceholder: 'contact@company.com',
    phone: 'Phone',
    phonePlaceholder: '+1-555-123-4567',
    createError: 'Error creating counterparty',
    wfirmaSync: 'wFirma Synchronization',
    wfirmaId: 'wFirma ID',
    removeSync: 'Remove Synchronization',
    unsyncConfirm: 'Are you sure you want to remove wFirma synchronization? You can re-sync the counterparty later.',
    wfirmaSyncHint: 'After removing synchronization, you can re-sync the counterparty',
    details: {
      title: 'Counterparty Information',
      notFound: 'Counterparty not found',
      invoicesTitle: 'Counterparty Invoices',
      loadingInvoices: 'Loading invoices...',
      noInvoices: 'No invoices found'
    }
  },

  // Correction Invoices
  correctionInvoices: {
    title: 'Correction Invoices',
    manageCorrections: 'Manage Corrections',
    description: 'Go to the correction invoice management page to create and view corrections.',
    createCorrection: 'Create Correction',
    viewCorrections: 'View Corrections',
    noCorrectionsFound: 'No correction invoices found',
    tryAgain: 'Try Again',
    statuses: {
      DRAFT: 'Draft',
      SENT: 'Sent',
      ACCEPTED: 'Accepted',
      REJECTED: 'Rejected'
    },
    types: {
      CORRECTION: 'Correction',
      CANCELLATION: 'Cancellation',
      REPLACEMENT: 'Replacement'
    },
    tableHeaders: {
      number: 'Number',
      date: 'Date',
      type: 'Type',
      status: 'Status',
      difference: 'Difference',
      reason: 'Reason',
      actions: 'Actions'
    },
    statusOptions: {
      send: 'Send',
      accept: 'Accept',
      reject: 'Reject'
    },
    delete: 'Delete',
    deleteConfirm: 'Are you sure you want to delete this correction invoice?',
    pagination: {
      showing: 'Showing',
      of: 'of',
      records: 'records'
    },
    errors: {
      updateStatus: 'Error updating status',
      deleteError: 'Error deleting correction invoice',
      downloadError: 'Error downloading PDF'
    },
    modal: {
      title: 'Create Correction Invoice',
      originalInvoice: 'Original Invoice',
      selectOriginalInvoice: 'Select Original Invoice',
      searchInvoice: 'Search by invoice number...',
      noInvoicesFound: 'No invoices found',
      correctionNumber: 'Correction Number',
      correctionDate: 'Correction Date',
      reason: 'Correction Reason',
      reasonPlaceholder: 'Describe the reason for correction',
      correctionType: 'Correction Type',
      items: 'Items',
      addItem: 'Add Item',
      removeItem: 'Remove Item',
      description: 'Description',
      unitOfMeasure: 'Unit of Measure',
      originalQuantity: 'Original Quantity',
      originalUnitPrice: 'Original Unit Price',
      originalTotalPrice: 'Original Total Price',
      originalTaxRate: 'Original Tax Rate',
      originalTaxAmount: 'Original Tax Amount',
      correctedQuantity: 'Corrected Quantity',
      correctedUnitPrice: 'Corrected Unit Price',
      correctedTotalPrice: 'Corrected Total Price',
      correctedTaxRate: 'Corrected Tax Rate',
      correctedTaxAmount: 'Corrected Tax Amount',
      save: 'Save',
      cancel: 'Cancel',
      saving: 'Saving...',
      loading: 'Loading...',
      error: 'Error creating correction invoice',
      loadError: 'Error loading original invoice',
      createError: 'Error creating correction invoice',
      // Validation messages
      required: 'is required',
      requiredF: 'is required',
      // Column headers for items table (short versions for UI)
      originalPrice: 'Orig. Price',
      correctedPrice: 'Corr. Price',
      originalAmount: 'Orig. Amount',
      correctedAmount: 'Corr. Amount',
      difference: 'Difference',
      remove: 'Remove'
    }
  },
  invoiceNumbering: {
    title: 'Invoice Numbering Settings',
    template: 'Numbering Template',
    templateDescription: {
      NN_MM_YYYY: 'Sequence number/month/year (e.g.: 01/09/2025)',
      NN_YYYY: 'Sequence number/year (e.g.: 01/2025)',
      NN_MM_YYYY_ID: 'Sequence number/month/year/suffix (e.g.: 01/09/2025/ABC)'
    },
    suffix: 'Suffix',
    suffixPlaceholder: 'Enter suffix (e.g.: ABC, 2025)',
    currentSequence: 'Current Sequence Number',
    nextNumber: 'Next invoice number will be: {number}',
    preview: 'Preview',
    save: 'Save',
    saving: 'Saving...',
    loadError: 'Error loading settings',
    saveError: 'Error saving settings',
    generateNew: 'Generate New Number',
    generateNewTooltip: 'Generate new number'
  },
  correctionInvoiceNumbering: {
    title: 'Correction Invoice Numbering Settings',
    template: 'Numbering Template',
    templateDescription: {
      NN_MM_YYYY: 'Sequence number/month/year (e.g.: 01/09/2025)',
      NN_YYYY: 'Sequence number/year (e.g.: 01/2025)',
      NN_MM_YYYY_ID: 'Sequence number/month/year/suffix (e.g.: 01/09/2025/KOR)'
    },
    suffix: 'Suffix',
    suffixPlaceholder: 'Enter suffix (e.g.: KOR, ABC)',
    currentSequence: 'Current Sequence Number',
    nextNumber: 'Next correction invoice number will be: {number}',
    preview: 'Preview',
    save: 'Save',
    saving: 'Saving...',
    loadError: 'Error loading settings',
    saveError: 'Error saving settings',
    generateNew: 'Generate New Number',
    generateNewTooltip: 'Generate new number'
  },
  settings: {
    sections: {
      invoiceNumbering: 'Invoice Numbering',
      correctionInvoiceNumbering: 'Correction Invoice Numbering',
      integrations: 'Integrations',
      apiKeys: 'API keys'
    },
    apiKeys: {
      title: 'API keys (document connector)',
      hint: 'The key grants access to /api/connector/v1: counterparties, incoming invoices, contracts, and issued invoices (search, status, payments). Shown only once on create.',
      name: 'Name',
      scopes: 'Scopes',
      create: 'Create key',
      copyOnce: 'Copy the key now — it will not be shown again:',
      active: 'Active',
      empty: 'No keys',
      revoke: 'Revoke',
      revokeConfirm: 'Revoke this key?',
      revoked: 'Revoked'
    }
  },
  integrations: {
    wfirma: {
      title: 'wFirma Integration',
      description: 'Configure connection to wFirma for contractor synchronization',
      companyId: 'wFirma Company ID',
      companyIdHint: 'Your company ID in wFirma system',
      accessKey: 'Access Key',
      accessKeyPlaceholder: 'Enter Access Key',
      secretKey: 'Secret Key',
      secretKeyPlaceholder: 'Enter Secret Key',
      secretKeyHint: 'Displayed only once when created',
      appKey: 'App Key',
      appKeyPlaceholder: 'Enter App Key',
      appKeyHint: 'Issued by wFirma.pl individually for each application',
      loadError: 'Error loading configuration',
      saveError: 'Error saving configuration',
      saveSuccess: 'Configuration saved successfully',
      deleteError: 'Error deleting configuration',
      deleteSuccess: 'Configuration deleted',
      deleteConfirm: 'Are you sure you want to delete wFirma configuration?',
      fillAllFields: 'Please fill all fields',
      bulkInvoicesTitle: 'Send invoices to wFirma for a period',
      bulkInvoicesHint:
        'Pick a date range. Without "Resend", invoices already linked to wFirma are skipped. With resend enabled, old links are cleared and invoices are created again in wFirma.',
      periodFrom: 'From',
      periodTo: 'To',
      dateField: 'Filter by',
      dateFieldIssue: 'Issue date',
      dateFieldSale: 'Sale date',
      forceResync: 'Resend (clear existing wFirma link)',
      sendPeriod: 'Send to wFirma',
      periodDatesRequired: 'Enter start and end dates',
      resultTotal: 'Selected',
      resultSuccess: 'Sent',
      resultSkipped: 'Skipped (already in wFirma)',
      resultFailed: 'Failed',
      errorList: 'Error list',
      resetInvoicesTitle: 'Reset sent invoices to drafts',
      resetInvoicesHint:
        'Invoices with status Sent in the selected period will be moved back to Draft and their wFirma ID will be cleared. Use this before sending invoices manually one by one.',
      resetToDraftButton: 'Reset to drafts',
      resetToDraftResult: 'Moved to drafts',
      resetSkippedNotSent: 'Skipped (status not selected)',
      resetStatusesLabel: 'Statuses to reset',
      resetStatusesRequired: 'Select at least one status',
      resetConfirm: 'Move all sent invoices in this period back to drafts and clear their wFirma ID?',
      vatCodesTitle: 'wFirma VAT codes check',
      vatCodesHint: 'Refreshes VAT codes from the current wFirma account and shows a basic check for key rates/codes.',
      vatCodesRefreshButton: 'Refresh and check VAT codes',
      vatCodesTotal: 'Total VAT codes',
      vatCodesListTitle: 'VAT codes list from wFirma',
      accounts: {
        title: 'wFirma Accounts',
        description: 'Synchronize and link company accounts with wFirma accounts',
        sync: 'Sync Accounts',
        syncSuccess: 'Accounts synchronized successfully',
        syncError: 'Error syncing accounts',
        autoMap: 'Auto Link',
        autoMapSuccess: 'Accounts auto-linked',
        autoMapError: 'Error auto-linking accounts',
        wfirmaAccounts: 'wFirma Accounts',
        noWFirmaAccounts: 'No synchronized accounts. Click "Sync Accounts" to load.',
        ourAccounts: 'Our Accounts',
        noOurAccounts: 'No company accounts',
        mappedTo: 'Linked to',
        selectWFirmaAccount: 'Select wFirma account:',
        selectAccount: '-- Select Account --',
        noMatchingCurrency: 'No wFirma accounts with currency',
        map: 'Link',
        mapError: 'Error linking accounts',
        unmap: 'Unlink',
        unmapConfirm: 'Are you sure you want to remove the link?',
        unmapError: 'Error unlinking accounts',
        linkWFirmaAccount: 'Link to wFirma Account',
        selectWFirmaAccountForEdit: 'Select wFirma account to link'
      }
    }
  },
  wfirma: {
    accounts: {
      title: 'wFirma Accounts',
      description: 'Synchronize and link company accounts with wFirma accounts',
      sync: 'Sync Accounts',
      syncSuccess: 'Accounts synchronized successfully',
      syncError: 'Error syncing accounts',
      autoMap: 'Auto Link',
      autoMapSuccess: 'Accounts auto-linked',
      autoMapError: 'Error auto-linking accounts',
      wfirmaAccounts: 'wFirma Accounts',
      noWFirmaAccounts: 'No synchronized accounts. Click "Sync Accounts" to load.',
      ourAccounts: 'Our Accounts',
      noOurAccounts: 'No company accounts',
      mappedTo: 'Linked to',
      selectWFirmaAccount: 'Select wFirma account:',
      selectLocalAccount: 'Select local account:',
      selectAccount: '-- Select Account --',
      noMatchingCurrency: 'No wFirma accounts with currency',
      map: 'Link',
      mapError: 'Error linking accounts',
      unmap: 'Unlink',
      unmapConfirm: 'Are you sure you want to remove the link?',
      unmapError: 'Error unlinking accounts',
      linkWFirmaAccount: 'Link to wFirma Account',
      selectWFirmaAccountForEdit: 'Select wFirma account to link',
      syncStatus: 'wFirma Status',
      synchronized: 'Synchronized',
      notSynchronized: 'No',
      clearLocal: 'Remove local wFirma accounts',
      clearLocalHint:
        'After switching wFirma integration, clear the local cache, then sync and link accounts again. Nothing is deleted in wFirma.',
      clearLocalConfirm:
        'Remove all locally stored wFirma accounts and bank-account links? Nothing is deleted in wFirma. Then click "Sync Accounts".',
      clearLocalSuccess: 'Removed entries',
      clearLocalError: 'Failed to remove local wFirma accounts'
    }
  }
};
